import { render } from "./IconleftTextright.vue?vue&type=template&id=56d87f9d&scoped=true"
import script from "./IconleftTextright.vue?vue&type=script&lang=js"
export * from "./IconleftTextright.vue?vue&type=script&lang=js"

import "./IconleftTextright.vue?vue&type=style&index=0&id=56d87f9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d87f9d"]])

export default __exports__